module.exports = __webpack_public_path__ + "img/meditation.a3a29a2d.svg";